// extracted by mini-css-extract-plugin
export default {"borderStrokeTop":"z3Bz0vJy1sJTVXPBOJ2K","borderStrokeBottom":"JmQJPV4eCu43ujC4JJVp","borderSolid":"XIRW6jBqdZ0XDd7POhqu"};